import { useEffect, useCallback } from 'react';
import { useBoolean } from '@entegral/helpers.react/hooks/boolean';
import { getFromCache, putIntoCache } from '@entegral/helpers.react/settings';

let CACHE = {};
let CACHE_KEY = 'map-search-properties';
let EXPIRATION_TIME = 1 * 60 * 1000;

export function useSearchCache() {
  let [isCacheReady, setReady] = useBoolean(false);

  useEffect(() => {
    (async function () {
      let value = await getFromCache(CACHE_KEY);

      if (value) CACHE = value;

      setReady();
    })();
  }, []);

  let getFrom = useCallback((hash) => {
    let entry = CACHE[hash];

    if (entry && entry.expireAfter > Date.now()) return entry.payload;

    delete CACHE[hash];
    putIntoCache(CACHE_KEY, CACHE);

    return null;
  }, [CACHE]);

  let putInto = useCallback((hash, payload) => {
    CACHE[hash] = {
      payload,
      expireAfter: Date.now() + EXPIRATION_TIME,
    };

    putIntoCache(CACHE_KEY, CACHE);
  }, [CACHE]);

  return {
    getFromCache: getFrom,
    putIntoCache: putInto,
    isCacheReady,
  };
}

